export default __webpack_public_path__ + "images/9b7cb4e17d0e163faa827ec489c9b854-x-error.svg";